import axios from 'axios';
import { baseUrl, withAuth } from '../auth/helper';

export default {
  postLicense: withAuth(async (params, options) => {
    const response = await axios.post(`${baseUrl}/license`, params, options)
    return response
  }),
  getLicenses: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/license`, options)
    return response
  }),
}